export const ENDPOINTS = {
  getGiftCardBookings: '/gateway/admin/gift-cards/:code/bookings',
} as const;

export const CORE_QUERY_KEYS = {
  giftcard: 'admin-giftcard',
} as const;
